import { TrainingPlanCard } from '@rouvydev/web-components/cards'
import { useTranslation } from 'react-i18next'
import { ThumborUrlBuilder } from 'thumbor-url-builder-ts'
import { NormalizedLink } from '~/components/normalized-link.tsx'
import { type TrainingPlanOverviewFragment } from '~/model/api.ts'
import { durationInWeeks } from '~/utils/training-plans'

const thumbor = new ThumborUrlBuilder(ENV.THUMBOR_SECURITY, ENV.THUMBOR_URL)

type Props = Pick<
  TrainingPlanOverviewFragment,
  | 'id'
  | 'name'
  | 'description'
  | 'backgroundImageUrl'
  | 'expectedDurationDays'
  | 'totalDurationSeconds'
  | 'coinsForCompletion'
  | 'trainingUnitsCount'
  | 'trainingPlanTags'
> & {
  showProgressBar?: boolean
}

export function TrainingPlanOverview({
  id,
  name,
  description,
  backgroundImageUrl,
  expectedDurationDays,
  totalDurationSeconds,
  coinsForCompletion,
  trainingUnitsCount,
}: Props) {
  const { t } = useTranslation(['collections'])

  const url = `${ENV.RIDERS_PORTAL_URL}/training-plans/${id}`

  const duration = durationInWeeks(expectedDurationDays)

  const thumborImageUrl = thumbor
    .setImagePath(encodeURIComponent(backgroundImageUrl))
    .buildUrl()

  return (
    <div>
      <TrainingPlanCard
        trainingPlan={{
          title: name,
          image: thumborImageUrl,
          description,
        }}
        stats={{
          coins: coinsForCompletion,
          expectedDurationDays,
          totalDurationSeconds,
          trainingUnitsCount,
        }}
        strings={{
          done: t('collections::training_plan_card.status_done'),
          joined: t('collections::training_plan_card.status_joined'),
          hours: t('collections::training_plan_card.hours_label'),
          duration_week: t('collections::training_plan_card.week', {
            count: duration,
          }),
          per_week: t('collections::training_plan_card.per_week'),
        }}
        link={<NormalizedLink to={url} />}
        useFixedSize
      />
    </div>
  )
}
